import { UserInfo } from "../../../domain/model/user-info";

export class SyncStoreLastServerSyncInfo {

  constructor(
    readonly lastServerUpdate: Date | null,
    readonly lastLocalUpdate: Date | null,
    readonly lastEditedByUser: UserInfo | null) { }
}
